<template>
  <div>
    <div class="top-nav">
      <div class="project">{{ $t("GL.platformName") }}</div>
      <div class="user">
        <template v-if="isLogin">
          <div class="password" @click="showChangePasswordDialog">
            {{ $t("GL.updatePswd") }}
          </div>
          <el-popover
            placement="bottom"
            width="170"
            :trigger="role == '2' ? 'click' : 'manual'"
          >
            <div>
              <div class="qrcode" ref="qrCodeUrl"></div>
              <b class="qrcodeTip">{{ $t("GL.bindWxTip") }}</b>
            </div>
            <div
              slot="reference"
              style="display: flex; align-items: center; cursor: pointer"
            >
              <img v-if="!!avatar" class="avatar" :src="avatar" />
              <div class="name">{{ accountName }}</div>
            </div>
          </el-popover>
          <el-select
            v-if="showLSelector"
            v-model="language"
            :placeholder="$t('GL.selectPlaceholder')"
            class="languageSelector"
            @change="changeLanguage"
            size="mini"
          >
            <el-option
              v-for="item in languageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <div class="logout" @click="logout">{{ $t("GL.logout") }}</div>
        </template>
      </div>
    </div>
    <div class="placeholder"></div>
    <el-dialog
      :visible="mDialog.visible"
      :title="$t('GL.updatePswd')"
      @close="mDialog.visible = false"
      :close-on-click-modal="false"
    >
      <edit-password
        ref="mDialogForm"
        @saveResult="handleSaveResult"
      ></edit-password>
      <template slot="footer">
        <el-button @click="mDialog.visible = false">
          {{ $t("GL.cancel") }}</el-button
        >
        <el-button type="primary" @click="handleFormOk">
          {{ $t("GL.confirm") }}</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import EditPassword from "@/components/form/EditPassword";
import QRCode from "qrcodejs2";
import Cookies from "js-cookie";

const authHelper = createNamespacedHelpers("auth");
const languageHelper = createNamespacedHelpers("language");

export default {
  name: "TopNav",
  data() {
    return {
      mDialog: {
        visible: false
      },
      showPopover: false,
      language: Cookies.get("t-language"),
      languageOptions: [
        {
          label: "简体中文",
          value: "zh-CN"
        },
        {
          label: "English",
          value: "en-US"
        }
      ]
    };
  },
  components: {
    EditPassword
  },
  computed: {
    ...authHelper.mapGetters([
      "accountName",
      "isLogin",
      "avatar",
      "phone",
      "role",
      "teacherId"
    ]),
    ...languageHelper.mapGetters(["showLSelector", "localeLanguage"])
  },
  watch: {
    localeLanguage: {
      handler: function(val) {
        this.language = val;
      },
      immediate: true
    }
  },
  mounted() {
    this.creatQrCode(this.teacherId);
  },
  methods: {
    changeLanguage(val) {
      this.$emit("changeLanguage", val);
      window.location.reload();
    },
    ...authHelper.mapActions(["authInvalid"]),
    async logout() {
      await this.$confirm(this.$t("GL.confirmLogout"));
      this.authInvalid();
    },
    async showChangePasswordDialog() {
      this.mDialog.visible = true;
      this.$nextTick(() => {
        this.$refs.mDialogForm.setDataForm({
          phone: this.phone
        });
      });
    },

    handleSaveResult({ isSuccess, message }) {
      if (isSuccess) {
        this.$message.success(this.$t("GL.changePswdSuc"));
        this.mDialog.visible = false;
      }
    },
    handleFormOk() {
      this.$refs.mDialogForm.updatePassword();
    },
    handleShowPopover() {
      this.showPopover = true;
    },
    creatQrCode(teacherId) {
      try {
        let qrCodeUrl = `https://mall.ieltsbro.com/bindWechat/bindTeacher?teacherId=${teacherId}`;
        if (process.env.NODE_ENV === "production") {
          qrCodeUrl = `https://mall.ieltsbro.com/bindWechat/bindTeacher?teacherId=${teacherId}`;
        }
        if (this.$refs.qrCodeUrl) {
          new QRCode(this.$refs.qrCodeUrl, {
            text: qrCodeUrl,
            width: 170,
            height: 170,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.placeholder {
  height: 60px;
  width: 100%;
}

.languageSelector {
  width: 100px;
  margin-left: 15px;
}

.top-nav {
  z-index: 4;
  height: 60px;
  width: 100%;
  background-color: #3377ff;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;

  .project {
    margin-left: 60px;
    font-size: 24px;
  }

  .user {
    display: flex;
    align-items: center;

    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin-right: 15px;
      background-color: #fff;
    }

    .logout {
      margin: 0 50px 0 15px;
      cursor: pointer;
    }

    .password {
      margin-right: 15px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/TopNav.vue